export default __webpack_public_path__ + "static/media/viber.8cf7427a.svg";